<!-- @format -->

<div>
  <span class="additional-data">
    <span><sis-mark-string [target]="result.code" [query]="textQuery" /></span>
    @if (searchTarget === "CourseUnit" && !isHomeUniversityResult(result)) {
      <span>
        @for (universityOrgId of getResultUniversityOrgIds(result); track universityOrgId) {
          <span>
            <sis-tiny-badge
              [content]="universityOrgId | organisation | async | entityName | localizedString"
              [variant]="'primary'"></sis-tiny-badge>
          </span>
        }
      </span>
    }
  </span>
</div>
